import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NotifierService } from 'angular-notifier';
import { FormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HeaderService } from 'src/app/core/header/header.service';
import { Pagination } from 'src/app/core/pagination/pagination';
import { ConfigService } from 'src/app/core/services/config.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { SortingService } from 'src/app/core/services/sorting.service';
import { StatusHandlerService } from 'src/app/core/services/status-handler.service';
import { UrlInstancesAndShedulesService } from '../url-instances-and-schedules.service';

@Component({
  selector: 'app-url-instances-and-schedules-list',
  templateUrl: './url-instances-and-schedules-list.component.html',
  styleUrls: ['./url-instances-and-schedules-list.component.scss'],
  providers: [DatePipe]
})
export class UrlInstancesAndSchedulesListComponent implements OnInit {

  @ViewChild('clientMaster')
  public clientMaster!: NgSelectComponent;

  public totalPages: number | any;
  public currentPage: number | any;
  public pagination: Pagination | any;
  public showLoader: boolean = false;
  public errorMessage: any = null;
  public rlSearchList: any = [];
  public urlInstancesAndSchedulesSearchList1: any = [];
  public urlInstancesAndSchedulesSearchList2: any = [];
  private readonly notifier: NotifierService;
  bsModalRef!: BsModalRef;
  public clientMasterOptionsList: any = [];
  public colSpan: number = 14;
  public modalRef?: BsModalRef;
  public wrapText: boolean = false;
  public columnValueList: any = null;
  public clientMasterId: any = [];
  public ProcessDate: null | string | undefined | any = new Date()
  public totalRecordsForPagination: number = 0;
  public config: PerfectScrollbarConfigInterface = {};
  public disableSendCMSBtn: boolean = true;
  public disableRejectBtn: boolean = true;
  public isSearch: boolean = false;
  public UrlInstanceandSchedulelist: any = [];
  validationError: string | null = null;
  public filteredData: any = [];
  public filters = {
    urlConfigurationMasterID: '',
    crawlingDate: '',
    crawlingStatus: '',
    ceServerName: '',
    comment:'',
    crawlingCompletedOn:'',
    updatedOn:'',
    createdOn:'',
    mastersheetId:'',
    PushToCMS:'',
    pushToCMS:'',
    statusName:''
  };
  public columnDropdownFilter = [
    {
      id: 1, name: 'Is equal to', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 2, name: 'Is not equal to', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 3, name: 'Starts with', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 4, name: 'Contains', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 5, name: 'Does not contain', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 6, name: 'Ends with', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 7, name: 'Is null', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 8, name: 'Is not null', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    }
  ];

  public columnList = [
    { value: 1, name: 'URL Detail ID', checked: true, index: -1, text: '', columnName: 'URLDetailID' },
    { value: 2, name: 'Schedule Master ID', checked: true, index: -1, text: '', columnName: 'ScheduleMasterID' },
    { value: 3, name: 'Schedule Name', checked: true, index: -1, text: '', columnName: 'ScheduleName' },
    { value: 4, name: 'Created On', checked: true, index: -1, text: '', columnName: 'CreatedOn' },
    { value: 5, name: 'Last Updated On', checked: true, index: -1, text: '', columnName: 'LastUpdatedOn' },
    { value: 6, name: 'Schedule Start Date', checked: true, index: -1, text: '', columnName: 'ScheduleStartDate' },
  ]

  public columnList1 = [
    { value: 1, name: 'URL Configuration Master ID', checked: true, index: -1, text: '', columnName: 'URLConfigurationMasterID' },
    { value: 2, name: 'CrawlingDate', checked: true, index: -1, text: '', columnName: 'CrawlingDate' },
    { value: 3, name: 'Crawling Status', checked: true, index: -1, text: '', columnName: 'CrawlingStatus' },
    { value: 4, name: 'CEServerName', checked: true, index: -1, text: '', columnName: 'CEServerName' },
    { value: 5, name: 'RetryAttempts', checked: true, index: -1, text: '', columnName: 'RetryAttempts' },
    { value: 6, name: 'Comment', checked: true, index: -1, text: '', columnName: 'Comment' },
    { value: 7, name: 'Created On', checked: true, index: -1, text: '', columnName: 'CreatedOn' },
    { value: 8, name: 'Last Updated On', checked: true, index: -1, text: '', columnName: 'LastUpdatedOn' },
    { value: 9, name: 'MastersheetId', checked: true, index: -1, text: '', columnName: 'MastersheetId' },
    { value: 10, name: 'PushToCMS', checked: true, index: -1, text: '', columnName: 'PushToCMS' },
    { value: 11, name: 'StatusName', checked: true, index: -1, text: '', columnName: 'StatusName' },
    // { value: 12, name: 'CrawlingCompletedOn', checked: true, index: -1, text: '', columnName: 'CrawlingCompletedOn' },
  ]

  constructor(private urlInstancesAndSchedulesService: UrlInstancesAndShedulesService,
    private errorHandler: ErrorHandlerService,
    private sortingService: SortingService,
    private configService: ConfigService,
    private notifierService: NotifierService,
    private statusService: StatusHandlerService,
    private headerService: HeaderService, public modalService: BsModalService,
    private datePipe: DatePipe,
    private router: Router,
    private cd: ChangeDetectorRef) {
    this.notifier = notifierService;
  }
  applyFilters() {

    this.filteredData = this.urlInstancesAndSchedulesSearchList2.filter((item: any) => {
      return (
        (this.filters.urlConfigurationMasterID === '' || (item.URLConfigurationMasterID && item.URLConfigurationMasterID.toString().includes(this.filters.urlConfigurationMasterID))) &&
        (this.filters.crawlingDate === '' || (item.CrawlingDate && this.isDateMatch(item.CrawlingDate, this.filters.crawlingDate)))&&
        (this.filters.crawlingStatus === '' || (item.CrawlingStatus && item.CrawlingStatus.toString().toLowerCase().includes(this.filters.crawlingStatus.toLowerCase()))) &&
        (this.filters.ceServerName === '' || (item.CEServerName && item.CEServerName.toLowerCase().includes(this.filters.ceServerName.toLowerCase()))) &&
        (this.filters.crawlingCompletedOn === '' || (item.CrawlingCompletedOn && this.isDateMatch(item.CrawlingCompletedOn, this.filters.crawlingCompletedOn)))&& 
        (this.filters.comment === '' || (item.Comment && item.Comment.toLowerCase().includes(this.filters.comment.toLowerCase()))) &&
        (this.filters.createdOn === '' || (item.CreatedOn && this.isDateMatch(item.CreatedOn, this.filters.createdOn)))&&     
        (this.filters.updatedOn === '' || (item.UpdatedOn && this.isDateMatch(item.UpdatedOn, this.filters.updatedOn)))&&
        (this.filters.mastersheetId === '' || (item.MastersheetId && item.MastersheetId.toLowerCase().includes(this.filters.mastersheetId.toLowerCase()))) &&
        (this.filters.pushToCMS === '' || (item.PushToCMS && item.PushToCMS.toLowerCase().includes(this.filters.pushToCMS.toLowerCase()))) &&
        (this.filters.statusName === '' || (item.StatusName && item.StatusName.toLowerCase().includes(this.filters.statusName.toLowerCase())))
      );
    });
  
    // Apply sorting after filtering
   
      this.sortData(this.pagination.columnName);
    
  }
  GetClientMasterOptions() {
    this.showLoader = true;
    this.urlInstancesAndSchedulesService.GetClientMasterOptions().subscribe({
      next: (data: any) => {
        this.clientMasterOptionsList = data.Data;
        if (this.clientMasterOptionsList.length > 0) {
          this.clientMasterId = this.clientMasterOptionsList[0].ClientMasterID;
        }

        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  NavigateToSourceUrl(ID: any, Url: any) {

    if (Url && !Url.includes('http')) {
      // Url = 'https:' + Url;
      this.router.navigate([]).then(result => { window.open('https:/' + Url, '_blank'); });
    }
    else {
      this.router.navigate([]).then(result => { window.open(Url, '_blank'); });
    }

  }

  downloadXml(xmlData: any) {
    const xmlContent = xmlData;
    if (xmlContent) {
      const blob = new Blob([xmlContent], { type: 'application/xml' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'ReviewdCrewledData.xml';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  }

  sortData(column: string) {

    if (this.pagination.columnName === column) {
      this.pagination.ascending = !this.pagination.ascending;
    } else {
      this.pagination.columnName = column;
      this.pagination.ascending = true;
    }
  
    // Perform sorting in-memory
    this.filteredData.sort((a: any, b: any) => {
      let comparison = 0;
  
      const valA = a[column];
      const valB = b[column];
  
      // Handle undefined values
      if (valA === undefined || valA === null) return 1;
      if (valB === undefined || valB === null) return -1;
  
      // Determine the type of the values
      const typeA = typeof valA;
      const typeB = typeof valB;
  
      // Sort based on type
      if (typeA === 'string' && typeB === 'string') {
        if (this.isValidDate(valA) && this.isValidDate(valB)) {
          // Parse and compare dates
          const dateA = new Date(valA);
          const dateB = new Date(valB);
          comparison = dateA.getTime() - dateB.getTime();
        } else {
          // Compare strings
          const upperA = valA.toUpperCase();
          const upperB = valB.toUpperCase();
  
          if (upperA > upperB) {
            comparison = 1;
          } else if (upperA < upperB) {
            comparison = -1;
          }
        }
      } else if (typeA === 'number' && typeB === 'number') {
        comparison = valA - valB;
      } else {
        // Handle cases where types are mixed or other types are encountered
        const strA = valA.toString();
        const strB = valB.toString();
  
        if (strA > strB) {
          comparison = 1;
        } else if (strA < strB) {
          comparison = -1;
        }
      }
  
      return this.pagination.ascending ? comparison : -comparison;
    });
  }
//   sortData(column: string) {
//     debugger;
//     if (this.pagination.columnName === column) {
//       this.pagination.ascending = !this.pagination.ascending;
//     } else {
//       this.pagination.columnName = column;
//       this.pagination.ascending = true;
//     }
//   this.filteredData.sort((a: any, b: any) => {
//     let comparison = 0;

//     const valA = a[column] ? a[column].toString().toUpperCase() : '';
//     const valB = b[column] ? b[column].toString().toUpperCase() : '';

//     if (valA > valB) {
//       comparison = 1;
//     } else if (valA < valB) {
//       comparison = -1;
//     }

//     return this.pagination.ascending ? comparison : -comparison;
//   });
// }
  isValidDate(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }
  
  isDateMatch(itemDate: Date | string, filterDate: string): boolean {
    if (!itemDate) return false;
    const itemDateString = this.formatDate(itemDate);
    return itemDateString.includes(filterDate);
  }
  formatDate(date: Date | string): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  }
  

  ngOnInit(): void {
    this.pagination = new Pagination("ID", false, 1);
    this.pagination.pageLength = 50;
    this.GetClientMasterOptions();
    this.GetUrlInstancesAndSchedules(this.pagination);
  }

  SortColumn(newColumn: string) {
    let pagination = this.sortingService.SortColumn(this.pagination.columnName, newColumn, this.pagination.ascending, 1, this.pagination.searchText);
    pagination.clientMasterId = this.pagination.clientMasterId
    pagination.URLConfigurationMasterID = this.pagination.URLConfigurationMasterID;
    pagination.masterSheetId = this.pagination.masterSheetId;
    pagination.ClientName = this.pagination.ClientName;
    pagination.regLakeStatusId = this.pagination.regLakeStatusId;
    pagination.PushToCMS = this.pagination.PushToCMS;
    pagination.IsSeleniumRequired = this.pagination.IsSeleniumRequired;
    pagination.CrawledMasterDataID = this.pagination.CrawledMasterDataID;
    pagination.UrlDetailID = this.pagination.UrlDetailID;
    pagination.CreatedOn = this.pagination.CreatedOn;
    pagination.CrawledJSONID = this.pagination.CrawledJSONID;
    pagination.ErrorMessage = this.pagination.ErrorMessage;
    pagination.SourceURLError = this.pagination.SourceURLError;
    pagination.FieldLevelError = this.pagination.FieldLevelError;
    pagination.TotalReceivedRecords = this.pagination.TotalReceivedRecords;
    pagination.ProcessedRecords = this.pagination.ProcessedRecords;
    pagination.ErrorRecords = this.pagination.ErrorRecords;
    pagination.BrowserType = this.pagination.BrowserType;
    pagination.sourceUrl = this.pagination.sourceUrl;
    pagination.CrawledData = this.pagination.CrawledData;
    pagination.searchString = this.pagination.searchString;
    pagination.searchText = this.pagination.searchText;
    pagination.isDeleted = this.pagination.isDeleted = false;
    pagination.pageLength = this.pagination.pageLength
    this.pagination = pagination;

    this.GetUrlInstancesAndSchedules(this.pagination);
  }

  Search(filterForm: any) {
    this.errorMessage = null;
    if (filterForm.invalid||!this.pagination.masterSheetId && !this.pagination.URLConfigurationMasterID) {
      this.errorMessage = 'Please enter either MasterSheet ID or URLConfigurationMaster ID.';
      return;
    }
    this.SearchUrlInstancesAndSchedulesData();
  }

  SearchUrlInstancesAndSchedulesData() {
    this.pagination.pageIndex = 1;
    this.isSearch = true;
    this.pagination.ProcessDate = this.datePipe.transform(this.ProcessDate, 'MM/dd/YYYY');
    this.GetUrlInstancesAndSchedules(this.pagination);
  }

  Reset() {
    this.isSearch = false;
    this.pagination.pageIndex = 1;
    this.pagination.pageLength = 50;
    this.pagination.searchText = "";
    this.pagination.URLConfigurationMasterID = null;
    this.pagination.masterSheetId = null;
    this.pagination.searchString = null;
    const tempClientID=this.clientMasterId;
    this.clientMasterId=null;
    this.pagination.clientMasterId=null;

    for (let i = 0; i < this.columnList.length; i++) {
      this.columnList[i].text = '';
    }
    for (let i = 0; i < this.columnDropdownFilter.length; i++) {
      this.columnDropdownFilter[i].activeURLDetailID = false;
      this.columnDropdownFilter[i].activeScheduleMasterId = false;
      this.columnDropdownFilter[i].activeScheduleName = false;
      this.columnDropdownFilter[i].activeScheduleStartDate = false;
      this.columnDropdownFilter[i].activeURLConfigurationMasterID = false;
      this.columnDropdownFilter[i].activeCrawlingDate = false;
      this.columnDropdownFilter[i].activeCrawlingStatus = false;
      this.columnDropdownFilter[i].activeCEServerName = false;
      this.columnDropdownFilter[i].activeCreatedOn = false;
      this.columnDropdownFilter[i].activeRetryAttempts = false;
      this.columnDropdownFilter[i].activeComment = false;
      this.columnDropdownFilter[i].activeLastUpdatedOn = false;
      this.columnDropdownFilter[i].activeMastersheetId = false;
      this.columnDropdownFilter[i].activePushToCMS = false;
      this.columnDropdownFilter[i].activeStatusName = false;
    }
    this.GetUrlInstancesAndSchedules(this.pagination);
    this.clientMasterId=tempClientID;
  }

  SearchColumnFilter(columnName: any, index: number) {
    this.columnValueList = null;
    let flag = false;
    if (index == -1) {
      index = 3;
    }
    for (let i = 0; i < this.columnDropdownFilter.length; i++) {
      this.columnDropdownFilter[i].activeURLDetailID = false;
      this.columnDropdownFilter[i].activeScheduleMasterId = false;
      this.columnDropdownFilter[i].activeScheduleName = false;
      this.columnDropdownFilter[i].activeScheduleStartDate = false;
      this.columnDropdownFilter[i].activeURLConfigurationMasterID = false;
      this.columnDropdownFilter[i].activeCrawlingDate = false;
      this.columnDropdownFilter[i].activeCrawlingStatus = false;
      this.columnDropdownFilter[i].activeCEServerName = false;
      this.columnDropdownFilter[i].activeCreatedOn = false;
      this.columnDropdownFilter[i].activeRetryAttempts = false;
      this.columnDropdownFilter[i].activeComment = false;
      this.columnDropdownFilter[i].activeLastUpdatedOn = false;
      this.columnDropdownFilter[i].activeMastersheetId = false;
      this.columnDropdownFilter[i].activePushToCMS = false;
      this.columnDropdownFilter[i].activeStatusName = false;
    }

    for (let i = 0; i < this.columnList.length; i++) {
      if (this.columnList[i].columnName == columnName) {
        this.columnList[i].index = index;
      }

      if (this.columnList[i].text && this.columnList[i].index != -1) {
        if (this.columnList[i].columnName == 'URLDetailID') {
          this.columnDropdownFilter[this.columnList[i].index].activeURLDetailID = !this.columnDropdownFilter[this.columnList[i].index].activeURLDetailID
        }
        else if (this.columnList[i].columnName == 'ScheduleMasterID') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleMasterId = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleMasterId
        }
        else if (this.columnList[i].columnName == 'ScheduleName') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleName = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleName
        }
        else if (this.columnList[i].columnName == 'ScheduleStartDate') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleStartDate = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleStartDate
        }
        else if (this.columnList[i].columnName == 'URLConfigurationMasterID') {
          this.columnDropdownFilter[this.columnList[i].index].activeURLConfigurationMasterID = !this.columnDropdownFilter[this.columnList[i].index].activeURLConfigurationMasterID
        }
        else if (this.columnList[i].columnName == 'CrawlingDate') {
          this.columnDropdownFilter[this.columnList[i].index].activeCrawlingDate = !this.columnDropdownFilter[this.columnList[i].index].activeCrawlingDate
        }
        else if (this.columnList[i].columnName == 'CrawlingStatus') {
          this.columnDropdownFilter[this.columnList[i].index].activeCrawlingStatus = !this.columnDropdownFilter[this.columnList[i].index].activeCrawlingStatus
        }
        else if (this.columnList[i].columnName == 'CEServerName') {
          this.columnDropdownFilter[this.columnList[i].index].activeCEServerName = !this.columnDropdownFilter[this.columnList[i].index].activeCEServerName
        }
        else if (this.columnList[i].columnName == 'CreatedOn') {
          this.columnDropdownFilter[this.columnList[i].index].activeCreatedOn = !this.columnDropdownFilter[this.columnList[i].index].activeCreatedOn
        }
        else if (this.columnList[i].columnName == 'RetryAttempts') {
          this.columnDropdownFilter[this.columnList[i].index].activeRetryAttempts = !this.columnDropdownFilter[this.columnList[i].index].activeRetryAttempts
        }
        else if (this.columnList[i].columnName == 'Comment') {
          this.columnDropdownFilter[this.columnList[i].index].activeComment = !this.columnDropdownFilter[this.columnList[i].index].activeComment
        }
        else if (this.columnList[i].columnName == 'LastUpdatedOn') {
          this.columnDropdownFilter[this.columnList[i].index].activeLastUpdatedOn = !this.columnDropdownFilter[this.columnList[i].index].activeLastUpdatedOn
        }
        else if (this.columnList[i].columnName == 'MastersheetId') {
          this.columnDropdownFilter[this.columnList[i].index].activeMastersheetId = !this.columnDropdownFilter[this.columnList[i].index].activeMastersheetId
        }
        else if (this.columnList[i].columnName == 'PushToCMS') {
          this.columnDropdownFilter[this.columnList[i].index].activePushToCMS = !this.columnDropdownFilter[this.columnList[i].index].activePushToCMS
        }
        else if (this.columnList[i].columnName == 'StatusName') {
          this.columnDropdownFilter[this.columnList[i].index].activeStatusName = !this.columnDropdownFilter[this.columnList[i].index].activeStatusName
        }
        flag = true;
      }
      else if (this.columnList[i].index != -1 && (this.columnDropdownFilter[this.columnList[i].index].id == 7 || this.columnDropdownFilter[this.columnList[i].index].id == 8)) {
        if (this.columnList[i].columnName == 'URLDetailID') {
          this.columnDropdownFilter[this.columnList[i].index].activeURLDetailID = !this.columnDropdownFilter[this.columnList[i].index].activeURLDetailID
        }
        else if (this.columnList[i].columnName == 'ScheduleMasterID') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleMasterId = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleMasterId
        }
        else if (this.columnList[i].columnName == 'ScheduleName') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleName = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleName
        }
        else if (this.columnList[i].columnName == 'ScheduleStartDate') {
          this.columnDropdownFilter[this.columnList[i].index].activeScheduleStartDate = !this.columnDropdownFilter[this.columnList[i].index].activeScheduleStartDate
        }
        else if (this.columnList[i].columnName == 'URLConfigurationMasterID') {
          this.columnDropdownFilter[this.columnList[i].index].activeURLConfigurationMasterID = !this.columnDropdownFilter[this.columnList[i].index].activeURLConfigurationMasterID
        }
        else if (this.columnList[i].columnName == 'CrawlingDate') {
          this.columnDropdownFilter[this.columnList[i].index].activeCrawlingDate = !this.columnDropdownFilter[this.columnList[i].index].activeCrawlingDate
        }
        else if (this.columnList[i].columnName == 'CrawlingStatus') {
          this.columnDropdownFilter[this.columnList[i].index].activeCrawlingStatus = !this.columnDropdownFilter[this.columnList[i].index].activeCrawlingStatus
        }
        else if (this.columnList[i].columnName == 'CEServerName') {
          this.columnDropdownFilter[this.columnList[i].index].activeCEServerName = !this.columnDropdownFilter[this.columnList[i].index].activeCEServerName
        }
        else if (this.columnList[i].columnName == 'CreatedOn') {
          this.columnDropdownFilter[this.columnList[i].index].activeCreatedOn = !this.columnDropdownFilter[this.columnList[i].index].activeCreatedOn
        }
        else if (this.columnList[i].columnName == 'RetryAttempts') {
          this.columnDropdownFilter[this.columnList[i].index].activeRetryAttempts = !this.columnDropdownFilter[this.columnList[i].index].activeRetryAttempts
        }
        else if (this.columnList[i].columnName == 'Comment') {
          this.columnDropdownFilter[this.columnList[i].index].activeComment = !this.columnDropdownFilter[this.columnList[i].index].activeComment
        }
        else if (this.columnList[i].columnName == 'LastUpdatedOn') {
          this.columnDropdownFilter[this.columnList[i].index].activeLastUpdatedOn = !this.columnDropdownFilter[this.columnList[i].index].activeLastUpdatedOn
        }
        else if (this.columnList[i].columnName == 'MastersheetId') {
          this.columnDropdownFilter[this.columnList[i].index].activeMastersheetId = !this.columnDropdownFilter[this.columnList[i].index].activeMastersheetId
        }
        else if (this.columnList[i].columnName == 'PushToCMS') {
          this.columnDropdownFilter[this.columnList[i].index].activePushToCMS = !this.columnDropdownFilter[this.columnList[i].index].activePushToCMS
        }
        else if (this.columnList[i].columnName == 'StatusName') {
          this.columnDropdownFilter[this.columnList[i].index].activeStatusName = !this.columnDropdownFilter[this.columnList[i].index].activeStatusName
        }
        flag = true;
      }

    }
    if (!flag) {
      this.pagination.searchString = null;
      for (let i = 0; i < this.columnList.length; i++) {
        this.columnList[i].index = -1
      }
    }
    this.pagination.pageIndex = 1
    this.GetUrlInstancesAndSchedules(this.pagination);
  }

  GetReviewCrawledDataSearchByPageLength() {
    this.pagination.pageIndex = 1;
    this.GetUrlInstancesAndSchedules(this.pagination);
  }

  GetUrlInstancesAndSchedules(paginationdetail: any) {

    this.errorMessage = null;
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.clientMasterId;
    this.showLoader = true;
    this.urlInstancesAndSchedulesService.GetUrlInstancesAndSchdules(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        this.totalPages = data.Data.TotalPage;
        this.currentPage = data.Data.CurrentIndex;
        this.urlInstancesAndSchedulesSearchList1 = data.Data.Data[0].UrlInstanceAndSchedules_Result1;
        this.urlInstancesAndSchedulesSearchList2 = data.Data.Data[0].UrlInstanceAndSchedules_Result2;
        console.log(this.urlInstancesAndSchedulesSearchList2)
        this.totalRecordsForPagination = data.Data.TotalRecordsForPagination;
        this.applyFilters();
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status)
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

}

